import { c as _c } from "react/compiler-runtime";
import Info from './info.icon.svg';
import css from './size.module.scss';
import { formatSize } from './utils';
interface Props {
  value: string;
}
export function Size(t0) {
  const $ = _c(29);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = new TextEncoder().encode(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const bytes = t1.length;
  const ratio = Math.min(1, Math.max(0, bytes / 14336));
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={css.label}>CacheKey Size</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bytes) {
    t3 = formatSize(bytes);
    $[3] = bytes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className={css.value}>{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${ratio * 100}%`;
  let t6;
  if ($[7] !== t5) {
    t6 = <div className={css.progress}><span className={css.fill} style={{
        width: t5
      }} /></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={css.limit}><span className={css.slash}>/</span>{formatSize(14336)}</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== bytes || $[11] !== ratio) {
    t8 = bytes === 0 ? 0 : bytes >= 14336 ? 100 : Math.max(1, Math.min(99, Math.round(ratio * 100)));
    $[10] = bytes;
    $[11] = ratio;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <span className={css.chip}>{t8}%</span>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t9) {
    t10 = <div className={css.row}>{t4}{t6}{t7}{t9}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = Math.max(0, 14336 - bytes);
  let t12;
  if ($[19] !== t11) {
    t12 = formatSize(t11);
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <span>{t12} remaining</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className={css.info}><Info /></span>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <p className={css.note}>{t13}{t14}</p>;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t10 || $[27] !== t15) {
    t16 = <div className={css.stat}>{t2}{t10}{t15}</div>;
    $[26] = t10;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}